<template>
    <div>
        <CommonPopupFrame :isShowBackground="false" :isBlur="true" background="#fffc" :changeBottom="0" :changeHeight="100" :isOpen="isShowRequestForm" :closeCompleteAction="closeRequestForm">
            <div @click="closeRequestForm" style="padding: 16px 20px; font-weight: 700; width: 100px;">닫기</div>
            <div style="flex: 1; overflow-y: scroll; padding: 0 12px;">
                <div style="text-align: center; margin-top: 60px; font-size: 20px; font-weight: 700; line-height: 33px; margin-bottom: 40px;">아래의 요청서를 전달할게요</div>
                <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px;" v-if="Object.keys(requestInfo).length > 0">
                    <CommonPost :hideOption="true" :isDetail="true" :isFeed="true" :soccerHows="requestInfo"></CommonPost>
                </div>
            </div>
            <div style="padding: 0 12px;">
                <div @click="sendRequestForm" style="margin-bottom: 40px; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">보내기</div>
            </div>
        </CommonPopupFrame>
        <MakeRequestJoinForm :soccerhowIdx="soccerhowIdx" :isFromReportList="isFromReportList" :isHideBackBtn="true" :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import CommonPost from '@/components/soccerhowmain/CommonPost'
import MakeRequestJoinForm from "@/components/soccerhowmain/MakeRequestJoinForm";

export default {
    name: "SendOneRequestPost",
    components: { CommonPopupFrame, CommonPost, MakeRequestJoinForm },
    props: {
        requestInfo: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            isShowRequestForm: false,
            soccerhowIdx: -1,
            isShowMakeRequestJoinForm: false,
            isFromReportList: false
        }
    },
    created() {
        setTimeout(() => {
            this.isShowRequestForm = true
        }, 500)
    },
    methods: {
        sendRequestForm() {
            this.soccerhowIdx = this.requestInfo.idx
            this.isShowRequestForm = false
            this.isShowMakeRequestJoinForm = true
            this.isFromReportList = true
        },
        closeRequestForm() {
            this.isShowRequestForm = false
            this.isFromReportList = false
            setTimeout(() => {
                this.$GlobalStore.closeLastModal()
            }, 500)
        },
        closeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = false;
            setTimeout(() => {
                this.$GlobalStore.closeLastModal()
            }, 500)
        },
    }
}
</script>

<style scoped></style>